export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer__copyright">&copy; 2024 Mario MN</p>
    </footer>
  );
}
